export default "__VITE_ASSET__DEGkfJP3__"